import { faCopyright, faLaptopCode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import React from "react";

const Footer = () => {
  return (
    <div className="font-mono shadow-[rgba(0,_0,_0,_0.4)_50px_50px_100px] h-[100px] bg-gradient-to-b from-gray-900 to-gray-600 bg-gradient-to-r border-2 grid grid-cols-2 xs:py-1 sm:py-2">
      <div className="flex justify-center items-center text-white">
        <FontAwesomeIcon
          icon={faCopyright}
          className="border-2 border-teal-200 rounded-xl w-[15px] h-[15px] sm:w-[20px] sm:h-[20px] "
        />
        <span className="font-semibold ml-[10px] text-[10px] sm:text-[17px]">
          Rajwardhan's Portfolio 2023
        </span>
      </div>
      <div className="flex justify-center items-center text-white">
        <a
          href="https://www.linkedin.com/in/rajwardhanshinde/"
          target="_blank"
          rel="noreferrer"
        >
          <FontAwesomeIcon
            icon={faLinkedin}
            className="sm:w-[35px] sm:h-[35px] w-[25px] h-[25px] mr-[40px] sm:mr-[70px] rounded-xl hover:scale-110 duration-300 cursor-pointer"
          />
        </a>

        <a
          href="https://github.com/RajwardhanShinde"
          target="_blank"
          rel="noreferrer"
        >
          <FontAwesomeIcon
            icon={faGithub}
            className="sm:w-[35px] sm:h-[35px] w-[25px] h-[25px] mr-[40px] sm:mr-[70px] rounded-xl hover:scale-105 duration-300 cursor-pointer"
          />
        </a>
        <a href="https://leetcode.com/rss07/" target="_blank" rel="noreferrer">
          <FontAwesomeIcon
            icon={faLaptopCode}
            className="sm:w-[35px] sm:h-[35px] w-[25px] h-[25px] rounded-xl hover:scale-105 duration-300 cursor-pointer"
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
